<template>
  <div class="overview-container">
    <overview-container
      :title="'Needs Match'"
    >
      <overview-needs-wants
        :chip-data="getNeedsChipData"
        :pref-data="prefNeed"
      />
    </overview-container>

    <overview-container
      :title="'Wants Match'"
    >
      <overview-needs-wants
        :chip-data="getWantsChipData"
        :pref-data="prefWant"
      />
    </overview-container>

    <overview-container
      :title="'Notes'"
    >
      <overview-notes
        :feedback-notes="feedbackData.feedback.notes"
      />
    </overview-container>

    <overview-container
      :title="'Pics'"
    >
      <overview-pics
        :images="feedbackData.feedback.media"
      />
    </overview-container>
  </div>
</template>

<script>
import OverviewContainer from './overview/OverviewContainer'
import OverviewNeedsWants from './overview/OverviewNeedsWants'
import OverviewNotes from './overview/OverviewNotes'
import OverviewPics from './overview/OverviewPics'
import colors from '../../scss/_colors.scss'

export default {
  components: {
    OverviewContainer,
    OverviewNeedsWants,
    OverviewNotes,
    OverviewPics
  },
  props: {
    feedbackData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors
    }
  },
  computed: {
    getNeedsChipData() {
      return {
        type: 'Need',
        data: this.feedbackData.feedback.match.results.filter(item => item.wantNeed === 'Need' && item.match),
        class: 'pl-2',
        color: this.colors.hwayzTapestry
      }
    },
    getWantsChipData() {
      return {
        type: 'Want',
        data: this.feedbackData.feedback.match.results.filter(item => item.wantNeed === 'Want' && item.match),
        class: 'pl-2',
        color: this.colors.hwayzDarkenGreen
      }
    },
    prefWant() {
      const data = this.feedbackData.feedback.match.results.filter(item => item.wantNeed === 'Want')
      return {
        type: 'Want',
        match: data.filter(item => item.match).length,
        total: data.length,
        color: this.colors.hwayzDarkenGreen
      }
    },
    prefNeed() {
      const data = this.feedbackData.feedback.match.results.filter(item => item.wantNeed === 'Need')
      return {
        type: 'Need',
        match: data.filter(item => item.match).length,
        total: data.length,
        color: this.colors.hwayzTapestry
      }
    }
  }
}
</script>

<style lang="sass">
.overview-container
  display: flex
  flex-direction: row
  justify-content: space-between
</style>
